import { Button } from 'antd';

import styled from '@emotion/styled';

export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.bgGrey};
  border-radius: 8px;
  padding: 20px 20px 4px 20px;
  margin-bottom: 12px;
`;

export const Submit = styled.div`
  margin-top: 24px;
`;

/**
 * The suggestion control, sitting under the reference field as `extra`.
 *
 * A link-styled button rather than an icon: the accountant needs to know a reference *can* be
 * suggested, and an unlabelled glyph next to a field they have never had to fill before does not
 * say that.
 */
export const Regenerate = styled(Button)`
  padding: 0;
  height: auto;
  font-size: 12px;
`;
